import { SERVICES } from "@/lib/constants";

const IMG = {
    dent_repair:
        "https://images.pexels.com/photos/6870310/pexels-photo-6870310.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    scratch_paintwork:
        "https://images.pexels.com/photos/33602226/pexels-photo-33602226.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bumper_repair:
        "https://images.pexels.com/photos/6870310/pexels-photo-6870310.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    panel_replacement:
        "https://images.pexels.com/photos/5495045/pexels-photo-5495045.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    full_respray:
        "https://static.prod-images.emergentagent.com/jobs/bb655671-9efd-41ad-be79-c7624682c623/images/57d7228b7698a30898aacd8fdf1e96c1cd7ded7dc4980114a54af3c1807ac654.png",
    alloy_wheels:
        "https://images.unsplash.com/photo-1632823471799-c3812077da2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    rust_repair:
        "https://images.unsplash.com/photo-1632823471565-1ecf94f8799a?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
};

const PRICES = {
    dent_repair: "From NZ$200",
    scratch_paintwork: "From NZ$256",
    bumper_repair: "From NZ$320",
    panel_replacement: "From NZ$560",
    full_respray: "From NZ$2,640",
    alloy_wheels: "From NZ$144",
    rust_repair: "From NZ$280",
};

export default function Services() {
    const goQuote = () => {
        document
            .getElementById("quote")
            ?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative py-20 md:py-28 bg-carbon"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div>
                        <p className="uppercase text-xs tracking-[0.3em] text-electric mb-3">
                            What we fix
                        </p>
                        <h2 className="font-display text-4xl md:text-5xl text-white font-bold tracking-tight max-w-2xl leading-[1.05]">
                            From{" "}
                            <em className="not-italic text-safety">
                                small dings
                            </em>{" "}
                            to full restorations.
                        </h2>
                    </div>
                    <p className="text-slate-400 max-w-md leading-relaxed">
                        Whatever your car needs, we do it properly — and we
                        price it fairly. Transparent ranges, no surprises.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
                    {SERVICES.map((s, i) => {
                        const span =
                            i === 0
                                ? "md:col-span-7"
                                : i === 1
                                  ? "md:col-span-5"
                                  : "md:col-span-4";
                        return (
                            <button
                                key={s.key}
                                data-testid={`service-card-${s.key}`}
                                onClick={goQuote}
                                className={`${span} group relative text-left overflow-hidden border border-white/10 bg-carbon2 hover:border-electric/50 hover:shadow-glow-cyan hover:-translate-y-1.5 transition-all duration-500 min-h-[260px] md:min-h-[320px] rounded-2xl`}
                            >
                                <div
                                    className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                                    style={{
                                        backgroundImage: `url(${IMG[s.key]})`,
                                    }}
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-carbon via-carbon/70 to-carbon/20" />
                                <div className="relative h-full p-6 md:p-8 flex flex-col justify-end text-white">
                                    <div className="flex items-center justify-between mb-2">
                                        <div className="text-xs uppercase tracking-[0.2em] text-safety">
                                            0{i + 1}
                                        </div>
                                        <div className="px-3 py-1 bg-safety text-navy text-xs font-bold rounded-full shadow-sm">
                                            {PRICES[s.key]}
                                        </div>
                                    </div>
                                    <h3 className="font-display text-2xl md:text-3xl text-white font-medium">
                                        {s.label}
                                    </h3>
                                    <p className="mt-2 text-slate-200 text-sm font-light max-w-md">
                                        {s.blurb}
                                    </p>
                                    <span className="mt-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-safety group-hover:text-white transition-colors">
                                        Get a price →
                                    </span>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
